(function (window) {
  'use strict';

  const zipGeolocate = document.querySelector('.js-zip-geolocate');
  const inputZipGeolocate = document.querySelector('.js-input-zip-geolocate');
  const resetZipGeolocate = document.querySelector('.zip-geolocate--reset');
  const buttonZipGeolocate = document.querySelector('.zip-geolocate--zip');

  const activeZipGeolocateClass = 'js-zip-geolocate--active';
  const errorZipGeolocateClass = 'form-item--error';
  const errorInputClass = 'input-error';
  const errorInputZipGeolocateClass = 'zip-geolocate--input-error';
  const jsHiddenClass = 'js-hidden';

  function handlePageLoad(e) {
    if (inputZipGeolocate.value.trim()) {
      zipGeolocate.classList.add(activeZipGeolocateClass);
    }
  }

  function handleZipGeolocateInputChange(e) {
    if (e.target.value.trim()) {
      zipGeolocate.classList.add(activeZipGeolocateClass);
    }
    else {
      zipGeolocate.classList.remove(activeZipGeolocateClass);
    }
  }

  function setZipGeolocateError(message) {
    let errorZipGeolocate = document.querySelector('.zip-geolocate--input-error');

    if(!errorZipGeolocate) {
      errorZipGeolocate = document.createElement(`span`);
      errorZipGeolocate.classList.add(errorInputClass);
      errorZipGeolocate.classList.add(errorInputZipGeolocateClass);
      errorZipGeolocate.classList.add(jsHiddenClass);
      zipGeolocate.insertAdjacentElement('afterend', errorZipGeolocate);
    }

    errorZipGeolocate.textContent = message;
    errorZipGeolocate.classList.remove(jsHiddenClass);

    zipGeolocate.classList.add(errorZipGeolocateClass);
  }

  function unsetZipGeolocateError(e) {
    const errorZipGeolocate = document.querySelector('.zip-geolocate--input-error');

    if (errorZipGeolocate) {
      errorZipGeolocate.classList.add(jsHiddenClass);
      errorZipGeolocate.textContent = null;
    }

    zipGeolocate.classList.remove(errorZipGeolocateClass);
  }

  function handleZipGeolocateZipSubmit(e) {
    if (inputZipGeolocate.value.trim() === "" || inputZipGeolocate.value === null) {
      setZipGeolocateError(window.ris_i18n.empty_zip_code);
      inputZipGeolocate.addEventListener('input', unsetZipGeolocateError, {once: true});
      buttonZipGeolocate.dispatchEvent(new CustomEvent('zip-error'));
    } else {
      const errorZipGeolocate = zipGeolocate.querySelector('span.input-error');
      if((!errorZipGeolocate || errorZipGeolocate.classList.contains(jsHiddenClass)) && !zipGeolocate.classList.contains(errorZipGeolocateClass)) {
        buttonZipGeolocate.dispatchEvent(new CustomEvent('zip', {detail: {zip: inputZipGeolocate.value.trim()}}));
      } else {
        buttonZipGeolocate.dispatchEvent(new CustomEvent('zip-error'));
      }
    }
    e.preventDefault();
  }

  function handleZipGeolocateInputSubmit(e) {
    if(e.keyCode === 13) {
      e.target.removeEventListener(e.type, handleZipGeolocateInputSubmit);
      e.target.blur();
      handleZipGeolocateZipSubmit(e);
    }
  }

  function handleZipGeolocateInputFocusBlur(e) {
    const target = e.target;
    const value = target.value.trim();

    if(e.type === 'focus') {
      target.addEventListener('keyup', handleZipGeolocateInputSubmit);
      target.addEventListener('blur', handleZipGeolocateInputFocusBlur, {once: true});
    } else if(e.type === 'blur') {
      if(value !== "" && value !== null) {
        if(window.ris_i18n.zip_code_regex.test(value) === false) {
          setZipGeolocateError(window.ris_i18n.invalid_zip_code);
          e.preventDefault();
        } else {
          unsetZipGeolocateError(e);
        }
      }

      target.removeEventListener('keyup', handleZipGeolocateInputSubmit);
      target.addEventListener('focus', handleZipGeolocateInputFocusBlur, {once: true});
    }
  }

  function handleZipGeolocateReset(e) {
    zipGeolocate.classList.remove(activeZipGeolocateClass);
    inputZipGeolocate.value = '';
    inputZipGeolocate.focus();
  }

  function init() {
    if (zipGeolocate) {
      window.addEventListener('load', handlePageLoad);
      inputZipGeolocate.addEventListener('input', handleZipGeolocateInputChange);
      inputZipGeolocate.addEventListener('focus', handleZipGeolocateInputFocusBlur, {once: true});
      buttonZipGeolocate.addEventListener('click', handleZipGeolocateZipSubmit);
      resetZipGeolocate.addEventListener('click', handleZipGeolocateReset);
    }
  }

  init();

})(this);
